import { useState } from 'react';
import BookingIntentCreationDialog from './BookingIntentCreationDialog';
import { BookingIntentTableContainer } from './BookingIntentTable';

export const BookingIntentPage = () => {
    const [showBookingIntentDialog, setShowBookingIntentDialog] = useState(false);

    return (
        <div>
            <BookingIntentCreationDialog
                show={showBookingIntentDialog}
                onClickCancel={() => setShowBookingIntentDialog(false)}
                onClickConfirm={() => setShowBookingIntentDialog(false)}
            />
            <BookingIntentTableContainer onCreateBookingIntent={() => setShowBookingIntentDialog(true)}/>
        </div>
    );
};
